import { FC, useContext, useEffect, useRef, useState } from 'react'
import Bookmark from 'assets/img/bookmark.svg'
import EmptyBookmark from 'assets/img/bookmark-icon.svg'
import Highlighter from 'assets/img/highlighter.svg'
import { QuestionnaireContext } from './QuestionnaireContext'
import Cookies from 'js-cookie'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import ClearModal from './models/ClearModal'
import PauseExitModal from './models/PauseExitModal'
import FinishModal from './models/FinishModal'
import Choice from './Choice'
import SpeechControls from './SpeechControls'
// import BasicCalculator from "./BasicCalculator";
import { setMarkings } from 'util/RaphaelInit'
import HtmlParser from './HtmlParser'
import UnAvailableTestModal from './models/UnAvailableTest'
import AssesmentScoreModal from 'common/Modals/AssesmentScoreModal'
import Eraser from 'assets/img/eraser.svg'
import Draggable from 'react-draggable'
import Close from 'assets/img/remove-icon-bold.svg'
import AnswerSubmittingModal from './models/answerSubmittingModal'
import { updatePaperSize } from 'util/RaphaelInit'

interface Props {
  onRemoveHighlighter: () => void
}
const QuestionContainer: FC<Props> = (props) => {
  const { onRemoveHighlighter } = props
  const assessmentName = Cookies.get('assessmentName')
  const [bounds, setBounds] = useState<any>()
  const [pos, setPos] = useState({ x: 0, y: 0 })
  const calculatorContainerRef = useRef<HTMLDivElement>(null)
  const draggableNodeRef = useRef<HTMLDivElement>(null)

  const isMath =
    assessmentName && assessmentName?.indexOf('Math') > -1 ? true : false
  const isCalculatorAllowed = Cookies.get('allow_calculator') === 'true'

  const isTextToSpeech = Cookies.get('text_to_speech_enabled') === 'true'
  const answersRef = useRef<HTMLDivElement>(null)
  const questionsRef = useRef<HTMLDivElement>(null)
  const {
    closeCalculator,
    currentQuestion,
    questionIdx,
    onChange,
    tabIndex,
    setTabIndex,
    isHighlighterActive,
    onSpeak,
    isSpeechIconClicked,
    isPausedByTeacher,
    keyToSpeak,
    containerRef,
    showHighlightEraser,
    isExpand,
    setIsExpand,
    saveExpressionAndMarkings,
    showCalculator,
    setSketchWidth,
    setSketchLeft,
    setSketchHeight,
    setSketchHeightQues,
    setSketchWidthQues,
    sketchHeight
  } = useContext(QuestionnaireContext)

  useEffect(() => {
    const divElement = document.getElementById('question')?.querySelector('div')
    if (divElement && divElement.style?.maxWidth?.length) {
      divElement.style.maxWidth = 'unset'
    }
  }, [currentQuestion])

  useEffect(() => {
    const container = answersRef.current?.getBoundingClientRect()
    if (container) {
      setSketchWidth(container.width)
      setSketchLeft(container.left)
      setSketchHeight(answersRef.current?.scrollHeight)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [answersRef.current?.clientWidth])

  const handleExpand = () => {
    setIsExpand(!isExpand)

    setTimeout(() => {
      const updatedWidth = answersRef.current?.clientWidth

      updatePaperSize(updatedWidth, sketchHeight)
    }, 1100)
  }

  useEffect(() => {
    const container = questionsRef.current?.getBoundingClientRect()
    if (container) {
      setSketchWidthQues(container.width)
      setSketchHeightQues(questionsRef.current?.scrollHeight)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionsRef.current?.clientWidth])

  useEffect(() => {
    if (showCalculator && calculatorContainerRef.current) {
      const rectData = calculatorContainerRef.current?.getBoundingClientRect()
      if (rectData) {
        setBounds({
          left: -rectData.left,
          top: -(rectData.top + 145),
          right: window.innerWidth - rectData.right,
          bottom: window.innerHeight - rectData.bottom - 60
        })
      }
    } else {
      setBounds(undefined)
      setPos({ x: 0, y: 0 })
    }
  }, [showCalculator, calculatorContainerRef])

  useEffect(() => {
    const { penMarkings, penMarkingsQuestions } = currentQuestion
    setMarkings(penMarkings, penMarkingsQuestions)

    return () => {
      onRemoveHighlighter()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionIdx])

  if (!currentQuestion.id) {
    return null
  }

  const {
    passage_directions,
    direction,
    passage_1,
    passage_2,
    question,
    choice_1,
    choice_2,
    choice_3,
    choice_4,
    bookmark
  } = currentQuestion

  const hasTabs = !(passage_1 || passage_2)

  return (
    <div className='mainContent' id='highlight'>
      {isPausedByTeacher && (
        <div>
          <div className='mainContent-backDrop'></div>
          <div className='mainContent-alert loading'>
            <p>
              Assessment has been paused by instructor <span>.</span>
              <span>.</span>
              <span>.</span>
            </p>
          </div>
        </div>
      )}
      <div className={`mainContent-header ${hasTabs ? 'changing-width' : ''}`}>
        <div className='mainContent-header-empty'></div>
        <ClearModal />
        <PauseExitModal />
        <FinishModal />
        <AnswerSubmittingModal />
        <UnAvailableTestModal />
        <AssesmentScoreModal />

        <div className='mainContent-header-wrapper'>
          <div
            className={`mainContent__answer ${
              hasTabs ? 'changing-width' : ''
            } ${isExpand ? 'answer-sec-expand' : ''}`}
          >
            <div className='mainContent__answer-content'>
              <div className='mainContent__answer-paragraph'>
                {assessmentName}
              </div>
              {!hasTabs && (
                <button
                  onClick={handleExpand}
                  type='button'
                  className={`expand-desc`}
                >
                  <svg
                    className={`${isExpand ? 'open' : ''}`}
                    xmlns='http://www.w3.org/2000/svg'
                    width='30'
                    height='29'
                    viewBox='0 0 30 29'
                    fill='none'
                  >
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M2.76172 28.9999C1.65715 28.9999 0.761719 28.1045 0.761719 26.9999V2.52295C0.761719 1.41838 1.65715 0.522949 2.76172 0.522949H27.2387C28.3433 0.522949 29.2387 1.41838 29.2387 2.52295V26.9999C29.2387 28.1045 28.3433 28.9999 27.2387 28.9999H2.76172ZM10.2547 10.0069V6.22295H27.3397V27.1019H10.2537V23.3019H8.35372V27.1019H2.66172V6.22295H8.35472V10.0229L10.2547 10.0069ZM10.2547 15.7069H8.35472V11.9069H10.2547V15.7069ZM15.9497 17.6069H12.1497V21.4069H15.9497V25.2069L23.5437 19.5119L15.9497 13.8119V17.6069ZM8.35472 21.4069H10.2547V17.6069H8.35472V21.4069Z'
                      fill='#ffffff'
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
          <div
            className={`mainContent__question ${
              hasTabs ? 'changing-width' : ''
            } ${isExpand ? 'question-sec-hide' : ''}`}
          >
            <div className='mainContent__question-content'>
              <p className='mainContent__question-paragraph'>
                {bookmark ? (
                  <img
                    src={Bookmark}
                    alt='bookmark'
                    onClick={() => onChange('bookmark', false)}
                  />
                ) : (
                  <img
                    src={EmptyBookmark}
                    alt='bookmark'
                    onClick={() => onChange('bookmark', true)}
                  />
                )}
                {`Question ${questionIdx + 1}`}
              </p>
            </div>
            {isTextToSpeech && <SpeechControls isMath={isMath} />}
          </div>
        </div>

        <div
          className={`mainContent-header-empty ${
            isExpand ? 'empty-header-color' : ''
          }`}
        ></div>
      </div>

      <div
        ref={containerRef}
        style={{
          cursor: isHighlighterActive
            ? `url(${Highlighter}) 0 35, move`
            : showHighlightEraser
              ? `url(${Eraser}) 14 41, move`
              : 'auto'
        }}
        className={`mainContent__main ${hasTabs ? 'switch-off-column' : ''}`}
      >
        <div style={{ display: 'contents' }}>
          {!hasTabs && (
            <div className={`answers ${isExpand ? 'answer-sec-expand' : ''}`}>
              <div className={`answers-content `}>
                {passage_2 ? (
                  <Tabs
                    selectedIndex={tabIndex}
                    onSelect={(index: number, _: any, event: any) => {
                      saveExpressionAndMarkings()
                      const id = (event.target as Element).getAttribute(
                        'data-id'
                      )
                      id !== 'delete-icon' && setTabIndex(index)
                    }}
                  >
                    <TabList>
                      <Tab>Tab 1</Tab>
                      <Tab>Tab 2</Tab>
                    </TabList>

                    <div
                      style={{ position: 'relative' }}
                      id='sketchContainerELA'
                      ref={answersRef}
                      className='answers__editor math-editor'
                    >
                      {passage_directions && (
                        <div
                          className={`answers__editor-tab ${
                            isSpeechIconClicked && 'ondemandtts'
                          } ${
                            keyToSpeak === 'passage_directions' && 'playtts'
                          }`}
                          onClick={() => onSpeak('passage_directions')}
                        >
                          <span className='answers__editor-instructions'>
                            <HtmlParser
                              key={currentQuestion.id}
                              html={passage_directions}
                              id='passage_directions'
                            />
                          </span>
                        </div>
                      )}
                      <div
                        onClick={() => onSpeak('passage_1')}
                        className={`answers__editor-edit ${
                          isSpeechIconClicked && 'ondemandtts'
                        }`}
                      >
                        <TabPanel>
                          <div
                            className={`zoomAnimation  ${
                              isSpeechIconClicked && 'tts'
                            } table-scroll`}
                          >
                            <HtmlParser
                              key={currentQuestion.id}
                              html={passage_1}
                              id='passage_1'
                            />
                          </div>
                        </TabPanel>
                      </div>
                      <div
                        onClick={() => onSpeak('passage_2')}
                        className={`answers__editor-edit ${
                          isSpeechIconClicked && 'ondemandtts'
                        }`}
                      >
                        <TabPanel>
                          <div
                            className={`zoomAnimation   ${
                              isSpeechIconClicked && 'tts'
                            }  table-scroll`}
                          >
                            <HtmlParser
                              key={currentQuestion.id}
                              html={passage_2}
                              id='passage_2'
                            />
                          </div>
                        </TabPanel>
                      </div>
                    </div>
                  </Tabs>
                ) : (
                  <div
                    style={{ position: 'relative' }}
                    id='sketchContainerELA'
                    ref={answersRef}
                    className='answers__editor'
                  >
                    <div className='zoomAnimation'>
                      {passage_directions && (
                        <div
                          className={`answers__editor-tab ${
                            isSpeechIconClicked && 'ondemandtts'
                          }  ${
                            keyToSpeak === 'passage_directions' && 'playtts'
                          }`}
                          onClick={() => onSpeak('passage_directions')}
                        >
                          <span className='answers__editor-instructions p-0'>
                            <HtmlParser
                              key={currentQuestion.id}
                              html={passage_directions}
                              id='passage_directions'
                            />
                          </span>
                        </div>
                      )}

                      <div
                        className={`answers__editor-edit  ${
                          isSpeechIconClicked && 'tts'
                        } table-scroll`}
                      >
                        <HtmlParser
                          key={currentQuestion.id}
                          html={passage_1}
                          id='passage_1'
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <div
            style={{ position: 'relative' }}
            id='sketchContainerQuestions'
            ref={questionsRef}
            className={`questions ${
              hasTabs ? 'switch-off-column' : ''
            } {isExpand ? 'question-sec-hide' : ''}`}
          >
            <div className='questions-wrapper'>
              <div className='questions__question'>
                {direction && (
                  <div
                    className='questions__dialogue'
                    onClick={() => onSpeak('direction')}
                  >
                    <p
                      className={`${isSpeechIconClicked && 'ondemandtts'} ${
                        keyToSpeak === 'direction' && 'playtts'
                      }`}
                    >
                      <HtmlParser html={direction} id='direction' />
                    </p>
                  </div>
                )}
                <div
                  id='chr-ques'
                  className='questions__question-item instruction'
                >
                  <div
                    className={`${isSpeechIconClicked && 'ondemandtts'} ${
                      keyToSpeak === 'question' && 'playtts'
                    } questions__question-instruction`}
                    onClick={() => onSpeak('question')}
                  >
                    <HtmlParser html={question} id='question' />
                  </div>
                </div>

                <div className='questions__question-item'>
                  <Choice
                    choice='A'
                    choiceText={choice_1}
                    option={0}
                    answer={0}
                  />
                </div>
                <div className='questions__question-item choice-b'>
                  <Choice
                    choice='B'
                    choiceText={choice_2}
                    option={1}
                    answer={0}
                  />
                </div>
                <div className='questions__question-item choice-c'>
                  <Choice
                    choice='C'
                    choiceText={choice_3}
                    option={2}
                    answer={0}
                  />
                </div>
                <div className='questions__question-item choice-d'>
                  <Choice
                    choice='D'
                    choiceText={choice_4}
                    option={3}
                    answer={0}
                  />
                </div>
              </div>
            </div>
          </div>
          {
            //showCalculator && <BasicCalculator />
          }
        </div>
        {isCalculatorAllowed && (
          <Draggable
            nodeRef={draggableNodeRef as any}
            onDrag={(e: any, data: any) => {
              setPos({ x: data.x, y: data.y })
            }}
            position={pos}
            defaultPosition={{ x: 0, y: 0 }}
            bounds={bounds}
          >
            <div ref={draggableNodeRef} className='cal-main-container'>
              {showCalculator && (
                <button
                  onTouchEnd={closeCalculator}
                  onClick={closeCalculator}
                  type='button'
                  className='closeTooltipBtn'
                >
                  <img src={Close} alt='Close' />
                </button>
              )}

              <div
                style={{ cursor: 'move' }}
                ref={calculatorContainerRef}
                id='desmos-calculator'
              ></div>
            </div>
          </Draggable>
        )}
      </div>
    </div>
  )
}

export default QuestionContainer
